import 'babel-polyfill';

import Vue from 'vue';
import Vue2TouchEvents from 'vue2-touch-events';
import App from './App';

import router from '@/app/router';
import VuexRouterSync from 'vuex-router-sync';

import store from '@/app/store/';

Vue.use( Vue2TouchEvents );

VuexRouterSync.sync( store, router );

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});
